<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="WFDistributeConfigs.wdcid > 0 ? '编辑':'新建'"
        class="customer-edit"
        width="500px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="WFDistributeConfigs"
          :rules="ruleValidate"
          class="form"
          label-width="150px">
        <el-form-item label="流程名称" prop="flowName">
          <el-select v-model="WFDistributeConfigs.flowName" clearable placeholder="请选择">
            <el-option
                v-for="item in constants.flowName.$options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                @click.native="selectFlowName(item.value)"/>
          </el-select>
        </el-form-item>
        <el-form-item label="待授权节点">
          <el-select v-model="WFDistributeConfigs.workflowNodeName" clearable placeholder="请选择">
            <el-option
                v-for="item in approveNodeList"
                :key="item.approveNodeID"
                :label="item.approveNodeID"
                :value="item.approveNodeID"
                @click.native="selectApproveNodeName(item.approveNodeID)"/>
          </el-select>
        </el-form-item>
        <el-form-item label="待授权角色" prop="roleName">
          <el-select v-model="WFDistributeConfigs.roleName" clearable placeholder="请选择">
            <el-option
                v-for="item in roleList"
                :key="item.id"
                :label="item.roleName"
                :value="item.roleName"
                @click.native="selectRoleName(item.id)"/>
          </el-select>
        </el-form-item>
        <el-form-item label="待授权用户" prop="userName">
          <el-select v-model="WFDistributeConfigs.userName" clearable placeholder="请选择">
            <el-option
                v-for="item in userList"
                :key="item.systemUserID"
                :label="item.employeeName"
                :value="item.employeeName"
                @click.native="selectUserName(item.systemUserID)"/>
          </el-select>
        </el-form-item>
        <el-form-item label="节点对应处理角色">
          <el-select v-model="WFDistributeConfigs.approverRoleName" clearable placeholder="请选择">
            <el-option
                v-for="item in roleList"
                :key="item.id"
                :label="item.roleName"
                :value="item.roleName"
                @click.native="selectApproverRoleName(item.id)"/>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import constants from "../../../util/constants";

  export default {
    name:"WFDistributeConfigEdit",
    components: {},
    data() {
      return {
        constants,
        //flowNames: constant.toSelect(constant.flowName),
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        roleList: [],
        userList: [],
        approveNodeList: [],
        WFDistributeConfigs: {
          approveNodeItemInfos: "",
          approverRoleID: "",
          approverRoleName: "",
          descrpt: "",
          billType: "",
          employeeID: "",
          employeeName: "",
          flowId: "",
          flowName: "eMES销售订单",
          roleID: "",
          roleInfos: "",
          roleName: "",
          systemUserID: "",
          userName: "",
          workflowDistributeID: "",
          wdcid: "",
          workflowNodeName: "",
        },
        ruleValidate: {
          payNodeName: {required: true, message: "不能为空", trigger: "blur"},
        },
      };
    },
    methods: {
      open(id) {
        this.WFDistributeConfigs.wdcid = id;
        this.dialogVisible = true;
        if (id > 0) {
          this.getData();
        } else {
          this.selectFlowName("SaleOrder");
        }
        this.getListInit();
      },
      getData() {
        this.$http
          .get("basic", `workflowDistributeConfigs/${this.WFDistributeConfigs.wdcid}`)
          .then(resp => {
            this.WFDistributeConfigs = resp;
            console.log(this.WFDistributeConfigs);
            if (this.WFDistributeConfigs.flowName === "SAP销售订单") {
              this.selectFlowName("SAPSaleOrder");
            }else {
              this.selectFlowName("SaleOrder");
            }
            // this.getListInit();
          });
      },
      getListInit() {
        this.$http
          .get("basic", "workflowDistributeConfigs/selectInit")
          .then(resp => {
            console.log(resp.roleInfos);
            this.roleList = resp.roleInfos;
          });
      },
      selectFlowName(name) {
        this.$http
          .get("basic", `workflows/selectWorkflowByName/${name}`)
          .then(resp => {
            console.log(resp);
            this.getApproveNodeList(resp.workflowID);
          });
      },
      selectRoleName(id) {
        this.WFDistributeConfigs.roleID = id;
        this.getUserList(id);
      },
      selectApproverRoleName(id) {
        this.WFDistributeConfigs.approverRoleID = id;
        this.getUserList(id);
      },
      selectUserName(id) {
        this.WFDistributeConfigs.systemUserID = id;
      },
      selectApproveNodeName(id) {
        this.WFDistributeConfigs.workflowNodeName = id;
      },
      getApproveNodeList(id) {
        if (this.WFDistributeConfigs.wdcid > 0) {
          this.$http
            .get("basic", `approveNodeItems/selectApproveNodes/${id}`)
            .then(resp => {
              this.approveNodeList = resp;
            });
        } else {
          this.$http
            .get("basic", `approveNodeItems/selectApproveNodes/${id}`)
            .then(resp => {
              console.log(resp);
              this.approveNodeList = resp;
            });
        }

      },
      getUserList(id) {
        this.$http
          .get("basic", `systemUserDetails/selectDetailByRoleId/${id}`)
          .then(resp => {
            this.userList = resp;
          });
      },
      handleSubmit() {
        if (this.WFDistributeConfigs.wdcid > 0) {
          this.handleSubmitUpData();
        } else {
          this.handleSubmitSave();
        }
      },
      handleSubmitUpData() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", "workflowDistributeConfigs", this.WFDistributeConfigs)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      handleSubmitSave() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "workflowDistributeConfigs", this.WFDistributeConfigs)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
